import { render, staticRenderFns } from "./Veranstaltungen.vue?vue&type=template&id=affd1640&"
import script from "./Veranstaltungen.vue?vue&type=script&lang=js&"
export * from "./Veranstaltungen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports